<div class="groupnotes-editor-container">
    <ckeditor [config]="config" [disabled]="isDisabled" [editor]="Editor" [(ngModel)]="this.data" (change)="onChange($event)" (ready)="onReady($event)"></ckeditor>
</div>
